
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api';

export const saveServiceSubmission = async (submission) => {
    const payload = {
        serviceId: submission.serviceId,
        serviceTitle: submission.serviceTitle,
        formData: submission.formData
    };
    const res = await axios.post(`${API_BASE_URL}/services/submissions`, payload);
    return res.data;
};

export const getServiceSubmissions = async () => {
    const res = await axios.get(`${API_BASE_URL}/services/submissions`);
    return Array.isArray(res.data) ? res.data : [];
};

export const updateSubmissionStatus = async (id, status) => {
    const res = await axios.patch(`${API_BASE_URL}/services/submissions/${id}/status`, { status });
    return res.data;
};
